import React from "react";
import { Modal, Typography } from "antd";
import { inspectScheduleName } from "../../shared/scheduleNameValidation";

const { Text } = Typography;

const settleOnce = (resolve) => {
    let settled = false;
    return (result) => {
        if (settled) return;
        settled = true;
        resolve(result);
    };
};

export const confirmScheduleNameBeforeSave = async (name) => {
    const inspection = inspectScheduleName(name);
    if (!inspection.hasUnsupportedCharacters) {
        return { proceed: true, name, cleaned: false };
    }

    if (!inspection.cleanedName) {
        await new Promise((resolve) => {
            const finish = settleOnce(resolve);
            Modal.warning({
                title: "计划名称无法自动清理",
                content: "计划名称仅包含不可见字符，清理后将为空。请返回并填写可识别的计划名称。",
                okText: "返回修改",
                onOk: () => finish(),
                afterClose: () => finish(),
            });
        });
        return { proceed: false, name, cleaned: false };
    }

    return new Promise((resolve) => {
        const finish = settleOnce(resolve);
        Modal.confirm({
            title: "计划名称包含不可见字符",
            width: 600,
            content: (
                <div>
                    <p>
                        检测到 {inspection.summary}。这类字符不会正常显示，并可能导致导出文件无法下载。
                    </p>
                    <p style={{ marginBottom: 8 }}>清理后的计划名称：</p>
                    <Text code>{inspection.cleanedName}</Text>
                </div>
            ),
            okText: "清理后继续保存",
            cancelText: "取消，我自行修改",
            onOk: () => finish({ proceed: true, name: inspection.cleanedName, cleaned: true }),
            onCancel: () => finish({ proceed: false, name, cleaned: false }),
            afterClose: () => finish({ proceed: false, name, cleaned: false }),
        });
    });
};

export default confirmScheduleNameBeforeSave;
